export default "__VITE_ASSET__C3Lw7Xk1__"